import { useEffect, useState } from 'react'
import { Dropdown } from 'primereact/dropdown';
import axios from 'axios';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setShowLoading } from '../../features/sharedSlice';
import { Button } from 'primereact/button';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function BolgeRapor() {
    const pdf = new jsPDF('landscape', undefined, 'A4');
    const dispatch = useAppDispatch();
    const bolgeItems = [
        { label: 'Coğrafi Bölgeler', value: 'cografi_bolgeler_usr' },
        { label: 'Teşvik Bölgeleri', value: 'tesvik_bolgeleri_usr' },
        { label: 'İBBS Düzey 2', value: 'istatistik_bolge_duzey_usr' }
    ];
    const [selectedBolge, setSelectedBolge] = useState<any>(undefined)
    const token = useAppSelector(state => state.authState.token);
    const pdfPage = document.getElementById("tab2") as HTMLElement;

    const downloadPdf = () => {
        let page: any
        page = pdfPage

        html2canvas(page).then((canvas: any) => {
            pdf.addImage(canvas, "PNG", 10, 10, 270, 170);
            pdf.save("Bölge Raporu.pdf");
        });
    };

    const getOsbAndIstihdamByCografi = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/osbandistihdambycografi?token=${token}`)
            const data = response.data.data
            const categories = data.map((obj: any) => obj.bolge)
            const istihdam_sayisi = data.map((obj: any) => !Number.isNaN(Number(obj.istihdam_sayisi)) ? Number(obj.istihdam_sayisi) : 0)
            const osb_sayisi = data.map((obj: any) => !Number.isNaN(Number(obj.osb_sayisi)) ? Number(obj.osb_sayisi) : 0)

            new (window as any).Highcharts.Chart('osb_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'column',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 0,
                        beta: 0,
                        depth: 40,
                        viewDistance: 25
                    }
                },
                xAxis: {
                    gridLineWidth: 0,
                    categories: categories,
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                yAxis: {
                    title: {
                        enabled: false
                    },
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                tooltip: {
                    headerFormat: '<b>{point.key}</b><br>',
                    pointFormat: 'Değer: {point.y}'
                },
                title: {
                    text: `Coğrafi Bölgelere Göre OSB Sayısı`,
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'center'
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        depth: 25
                    }
                },
                series: [{
                    data: osb_sayisi
                }],
                exporting: {
                    enabled: false
                }
            });

            new (window as any).Highcharts.Chart('istihdam_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'column',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 0,
                        beta: 0,
                        depth: 40,
                        viewDistance: 25
                    }
                },
                xAxis: {
                    gridLineWidth: 0,
                    categories: categories,
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                yAxis: {
                    title: {
                        enabled: false
                    },
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                tooltip: {
                    headerFormat: '<b>{point.key}</b><br>',
                    pointFormat: 'Değer: {point.y}'
                },
                title: {
                    text: `Coğrafi Bölgelere Göre İstihdam Sayısı`,
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'center'
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        depth: 25
                    }
                },
                series: [{
                    data: istihdam_sayisi
                }],
                exporting: {
                    enabled: false
                }
            });
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    const getOsbAndIstihdamByTesvik = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/osbandistihdambytesvik?token=${token}`)
            const data = response.data.data
            const categories = data.map((obj: any) => obj.bolge)
            const istihdam_sayisi = data.map((obj: any) => !Number.isNaN(Number(obj.istihdam_sayisi)) ? Number(obj.istihdam_sayisi) : 0)
            const osb_sayisi = data.map((obj: any) => !Number.isNaN(Number(obj.osb_sayisi)) ? Number(obj.osb_sayisi) : 0)

            new (window as any).Highcharts.Chart('osb_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'column',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 0,
                        beta: 0,
                        depth: 40,
                        viewDistance: 25
                    }
                },
                xAxis: {
                    gridLineWidth: 0,
                    categories: categories,
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                yAxis: {
                    title: {
                        enabled: false
                    },
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                tooltip: {
                    headerFormat: '<b>{point.key}</b><br>',
                    pointFormat: 'Değer: {point.y}'
                },
                title: {
                    text: `Teşvik Bölgelerine Göre OSB Sayısı`,
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'center'
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        depth: 25
                    }
                },
                series: [{
                    data: osb_sayisi
                }],
                exporting: {
                    enabled: false
                }
            });

            new (window as any).Highcharts.Chart('istihdam_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'column',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 0,
                        beta: 0,
                        depth: 40,
                        viewDistance: 25
                    }
                },
                xAxis: {
                    gridLineWidth: 0,
                    categories: categories,
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                yAxis: {
                    title: {
                        enabled: false
                    },
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                tooltip: {
                    headerFormat: '<b>{point.key}</b><br>',
                    pointFormat: 'Değer: {point.y}'
                },
                title: {
                    text: `Teşvik Bölgelerine Göre İstihdam Sayısı`,
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'center'
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        depth: 25
                    }
                },
                series: [{
                    data: istihdam_sayisi
                }],
                exporting: {
                    enabled: false
                }
            });
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    const getOsbAndIstihdamByIBBS2 = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/osbandistihdambyibbs2?token=${token}`)
            const data = response.data.data
            const categories = data.map((obj: any) => obj.bolge)
            const istihdam_sayisi = data.map((obj: any) => !Number.isNaN(Number(obj.istihdam_sayisi)) ? Number(obj.istihdam_sayisi) : 0)
            const osb_sayisi = data.map((obj: any) => !Number.isNaN(Number(obj.osb_sayisi)) ? Number(obj.osb_sayisi) : 0)

            new (window as any).Highcharts.Chart('osb_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'column',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 0,
                        beta: 0,
                        depth: 40,
                        viewDistance: 25
                    }
                },
                xAxis: {
                    gridLineWidth: 0,
                    categories: categories,
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                yAxis: {
                    title: {
                        enabled: false
                    },
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                tooltip: {
                    headerFormat: '<b>{point.key}</b><br>',
                    pointFormat: 'Değer: {point.y}'
                },
                title: {
                    text: `İBBSD-2 Bölgelerine Göre OSB Sayısı`,
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'center'
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        depth: 25
                    }
                },
                series: [{
                    data: osb_sayisi
                }],
                exporting: {
                    enabled: false
                }
            });

            new (window as any).Highcharts.Chart('istihdam_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'column',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 0,
                        beta: 0,
                        depth: 40,
                        viewDistance: 25
                    }
                },
                xAxis: {
                    gridLineWidth: 0,
                    categories: categories,
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                yAxis: {
                    title: {
                        enabled: false
                    },
                    labels: {
                        style: { "color": "#ffffff", "fontSize": "10px" }
                    }
                },
                tooltip: {
                    headerFormat: '<b>{point.key}</b><br>',
                    pointFormat: 'Değer: {point.y}'
                },
                title: {
                    text: `İBBSD-2 Bölgelerine Göre İstihdam Sayısı`,
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'center'
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        depth: 25
                    }
                },
                series: [{
                    data: istihdam_sayisi
                }],
                exporting: {
                    enabled: false
                }
            });
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    const getParselInCografiByTahsis = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/tahsisbycografi?token=${token}`)
            const data = response.data.data
            const doluParsel = data.filter((obj: any) => obj.tahsis_durumu === 1)
            const bosParsel = data.filter((obj: any) => obj.tahsis_durumu === 2)
            const doluData = doluParsel.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })
            const bosData = bosParsel.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })
            new (window as any).Highcharts.Chart('dolu_parsel_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'Coğrafi Bölgelere Göre Toplam Dolu Parsel Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Parsel Sayısı',
                    data: doluData
                }]
            });

            new (window as any).Highcharts.Chart('bos_parsel_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'Coğrafi Bölgelere Göre Boş Parsel Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Parsel Sayısı',
                    data: bosData
                }]
            });
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    const getParselInTesvikByTahsis = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/tahsisbytesvik?token=${token}`)
            const data = response.data.data
            const doluParsel = data.filter((obj: any) => obj.tahsis_durumu === 1)
            const bosParsel = data.filter((obj: any) => obj.tahsis_durumu === 2)
            const doluData = doluParsel.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })
            const bosData = bosParsel.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })
            new (window as any).Highcharts.Chart('dolu_parsel_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'Teşvik Bölgelerine Göre Toplam Dolu Parsel Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Parsel Sayısı',
                    data: doluData
                }]
            });

            new (window as any).Highcharts.Chart('bos_parsel_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'Teşvik Bölgelerine Göre Boş Parsel Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Parsel Sayısı',
                    data: bosData
                }]
            });
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    const getParselInIBBS2ByTahsis = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/tahsisbyibbs2?token=${token}`)
            const data = response.data.data
            const doluParsel = data.filter((obj: any) => obj.tahsis_durumu === 1)
            const bosParsel = data.filter((obj: any) => obj.tahsis_durumu === 2)
            const doluData = doluParsel.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })
            const bosData = bosParsel.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })
            new (window as any).Highcharts.Chart('dolu_parsel_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'İBBSD-2 Bölgelerine Göre Toplam Dolu Parsel Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Parsel Sayısı',
                    data: doluData
                }]
            });

            new (window as any).Highcharts.Chart('bos_parsel_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'İBBSD-2 Bölgelerine Göre Boş Parsel Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Parsel Sayısı',
                    data: bosData
                }]
            });
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    const getUretimByCografi = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/uretimbycografi?token=${token}`)
            const data = response.data.data
            const chartData = data.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })

            new (window as any).Highcharts.Chart('uretim_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'Coğrafi Bölgelere Göre Üretim Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Değer',
                    data: chartData
                }]
            });
            dispatch(setShowLoading(false));
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    const getUretimByTesvik = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/uretimbytesvik?token=${token}`)
            const data = response.data.data
            const chartData = data.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })

            new (window as any).Highcharts.Chart('uretim_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'Teşvik Bölgelerine Göre Üretim Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Değer',
                    data: chartData
                }]
            });
            dispatch(setShowLoading(false));
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    const getUretimByIBBS2 = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/uretimbyibbs2?token=${token}`)
            const data = response.data.data
            const chartData = data.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })

            new (window as any).Highcharts.Chart('uretim_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'İBBSD-2 Bölgelerine Göre Üretim Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Değer',
                    data: chartData
                }]
            });
            dispatch(setShowLoading(false));
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    const getInsaatByCografi = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/insaatbycografi?token=${token}`)
            const data = response.data.data
            const chartData = data.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })

            new (window as any).Highcharts.Chart('insaat_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'Coğrafi Bölgelere Göre İnşaat Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Değer',
                    data: chartData
                }]
            });
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    const getInsaatByTesvik = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/insaatbytesvik?token=${token}`)
            const data = response.data.data
            const chartData = data.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })

            new (window as any).Highcharts.Chart('insaat_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'Teşvik Bölgelerine Göre İnşaat Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Değer',
                    data: chartData
                }]
            });
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    const getInsaatByIBBS2 = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/insaatbyibbs2?token=${token}`)
            const data = response.data.data
            const chartData = data.map((obj: any) => { return [obj.bolge, !Number.isNaN(Number(obj.count)) ? Number(obj.count) : 0] })

            new (window as any).Highcharts.Chart('insaat_sayisi', {
                colors: ['#008184', '#005455', '#b68a33', '#60471c'],
                chart: {
                    type: 'pie',
                    backgroundColor: '#1f2d40',
                    options3d: {
                        enabled: true,
                        alpha: 45
                    }
                },
                exporting: {
                    enabled: false
                },
                title: {
                    text: 'İBBSD-2 Bölgelerine Göre İnşaat Sayısı',
                    style: { "color": "#ffffff", "fontSize": "14px" },
                    align: 'left'
                },
                legend: {
                    enable: true,
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    itemStyle: { "color": "#ffffff", "fontSize": "10px" }
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y}</b>'
                },
                plotOptions: {
                    pie: {
                        innerSize: '50%',
                        depth: 20,
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    name: 'Değer',
                    data: chartData
                }]
            });
        } catch (error) {
            console.error(error);
            dispatch(setShowLoading(false));
        }
    }

    useEffect(() => {
        dispatch(setShowLoading(true))
        switch (selectedBolge) {
            case 'cografi_bolgeler_usr':
                getOsbAndIstihdamByCografi();
                getParselInCografiByTahsis();
                getUretimByCografi();
                getInsaatByCografi();
                break;
            case 'tesvik_bolgeleri_usr':
                getOsbAndIstihdamByTesvik();
                getParselInTesvikByTahsis();
                getUretimByTesvik();
                getInsaatByTesvik();
                break;
            case 'istatistik_bolge_duzey_usr':
                getOsbAndIstihdamByIBBS2();
                getParselInIBBS2ByTahsis();
                getUretimByIBBS2();
                getInsaatByIBBS2();
                break;

            default:
                break;
        }
    }, [selectedBolge])

    useEffect(() => {
        setSelectedBolge('cografi_bolgeler_usr')
    }, [token])

    return (
        <>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}>
                <div>
                    <div style={{ marginBottom: '5px' }}>Bölge Seçiniz</div>
                    <Dropdown className='dialog-dropdown' value={selectedBolge} options={bolgeItems} onChange={(e) => { setSelectedBolge(e.value); }} placeholder="Select a City" />
                </div>
                <div style={{ marginBottom: '10px' }}><Button className="pdf-button" label='PDF Dışa Aktar' onClick={downloadPdf} /></div>
            </div>
            <div style={{ width: '100%' }} id="tab2">
                <div style={{ width: '100%' }}>
                    <div className="rapor-row-container" >
                        <div className="rapor-row" style={{ width: '25%', height: '100%' }}>
                            <div id='insaat_sayisi' className="rapor-row-element" style={{ width: '100%', height: '49%' }}></div>
                            <div id='uretim_sayisi' className="rapor-row-element" style={{ width: '100%', height: '49%' }}></div>
                        </div>
                        <div className="rapor-row" style={{ width: '50%', height: '100%' }}>
                            <div id='osb_sayisi' className="rapor-row-element" style={{ width: '100%', height: '49%' }}></div>
                            <div id='istihdam_sayisi' className="rapor-row-element" style={{ width: '100%', height: '49%' }}></div>
                        </div>
                        <div className="rapor-row" style={{ width: '25%', height: '100%' }}>
                            <div id='dolu_parsel_sayisi' className="rapor-row-element" style={{ width: '100%', height: '49%' }}></div>
                            <div id='bos_parsel_sayisi' className="rapor-row-element" style={{ width: '100%', height: '49%' }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
